/**
 * Created by Victor Rojo on 2/12/19.
 */
import { Component, TemplateRef, ViewChild }     from '@angular/core';
import {PetrolDiscountTransactionService} from "./PetrolDiscountTransaction.service";
import {PetrolDiscountTransaction} from "./PetrolDiscountTransaction";
import {I18NService} from "../../shared/i18n/i18n.service";

import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

import {PetrolSettlementReportService} from "./PetrolSettlementReport.service";

@Component({
  templateUrl: './PetrolSettlementReport.component.html',
  styleUrls: ['./PetrolSettlementReport.component.css']
})
export class PetrolSettlementReportComponent {

  isLoading = false;
  tableMessages: any;
  rows: PetrolDiscountTransaction[] = [];
  searchDate:any;
  bsConfig: Partial<BsDatepickerConfig>;

  constructor(private petrolSettlementReportService: PetrolSettlementReportService,
              private i18nService: I18NService) {



    let startDate = new Date();
    startDate.setHours(0,0,0,0);
    this.searchDate = startDate;

    this.tableMessages = {};
    this.tableMessages.emptyMessage = this.i18nService.get("noDataToDisplay");
    this.tableMessages.totalMessage = this.i18nService.get("total");
    this.tableMessages.selectedMessage = this.i18nService.get("selected");

    this.bsConfig = Object.assign({}, { containerClass: "theme-custom left-align", showWeekNumbers: false});

    this.reloadData()

  }

  private reloadData(){
    this.isLoading = true;
    let startDate = new Date(this.searchDate.getTime());
    startDate.setHours(0,0,0,0);
    let endDate = new Date(startDate.getTime() + 86400000);
    this.petrolSettlementReportService.get(startDate.getTime(), endDate.getTime())
      .then(data => {
        this.rows = data;
        this.isLoading = false;
      });
  }

  onValueChange(any:any){

    this.reloadData();
  }

  sumValues(columnName) {
    return this.rows
      .map(row => row[columnName.prop])
      .reduce((a, b) => a + b, 0);
  }

  reload(){
    this.reloadData();
  }

}
